import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    STROLLER_PRODUCT_GALLERY_FETCH_TRIGGER,
    StrollerProductGalleryFetchNormalizedResponse,
    StrollerProductGalleryFetchTriggerAction,
    strollerProductGalleryFetchApi,
} from "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGallery.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { HistoryAction } from "@/mk2/services/browserHistory";
import { strollers_api_v2_get_stroller_product_photos_url } from "@/mk/urls/functions";

const logger = getLogger("strollers/StrollerProductGallery.sagas");

interface FetchApiResponse {
    body: StrollerProductGalleryFetchNormalizedResponse;
}

function* fetch({
    strollerSlug,
    strollerVariantId,
    xhr,
    location,
    routeNavigate,
}: StrollerProductGalleryFetchTriggerAction & XHRAction & HistoryAction) {
    yield put(strollerProductGalleryFetchApi.request(strollerSlug, strollerVariantId));

    try {
        const response: FetchApiResponse = yield call(() =>
            xhr.get(
                strollers_api_v2_get_stroller_product_photos_url({
                    strollerSlug,
                    strollerVariantId,
                }),
            ),
        );

        yield put(
            strollerProductGalleryFetchApi.success(strollerSlug, strollerVariantId, response.body),
        );
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, location, routeNavigate, logger);
        yield put(
            strollerProductGalleryFetchApi.failure(
                strollerSlug,
                strollerVariantId,
                normalizeError(error),
            ),
        );
    }
}

export default function* root() {
    yield all([takeLatest(STROLLER_PRODUCT_GALLERY_FETCH_TRIGGER, fetch)]);
}
